/**
 * This is the JS for getting data for the state and county maps.
 *
 * A new map can be initialized with the following:
 *
 *  $.ADLMap({
 *      type: 'county',
 *      state: 'Wisconsin',
 *      svgPaths: ''
 *      // You can override the other options here, if needed.
 *  }).init();
 */
(function ($) {
    $.ADLMap = function(options) {
        var adlMap = {
            // Option default. These can be overridden when initializing a new instance of this plugin.
            options: $.extend({
                'type': 'state',  // 'state' -> US Map, or 'county' -> Individual state maps.
                'state': null,    // Full name of the state being shown (only used for 'county' maps).

                // BATooltip elements.
                'tip': $( '.tip' ),
                'activator': $( '.activator' ),
                'mapWrapper': $('.state-map-wrapper'),

                // CSS selector for each path (either states or counties). This is the default for the US map.
                'svgPaths': 'svg.svg-state path'
            }, options),

            // Data returned by getMapData. State/county name, link, property count.
            mapData: [],

            /////////////

            /**
             * Calls an AJAX function to get data used for displaying SVG map data.
             *
             * AJAX function parameters:
             * type: 'state' -> US Map, or 'county' -> Individual state maps.
             * state: 2 letter abbreviation of state, for county type maps.
             */
            getMapData: function() {
                var plugin = this;

                $.when(
                    $.ajax({
                        url: uch_app.ajax_url,
                        type: 'POST',
                        data: {
                            security: uch_app.security,
                            action: 'get_properties_count',
                            type: plugin.options.type,  // 'state' or 'county'.
                            state: plugin.options.state // Full name of state, if US Map.
                        },
                        dataType: 'json',
                        success: function (result) {
                            console.log('success!');
                        },
                        error: function (error) {
                            console.log('error :( ');
                        }
                    })
                ).done(function( result ) {
                    console.log( result );
                    plugin.mapData = result;
                    plugin.loadMap();
                });
            },

            /**
             * Initializes the map. Removes loading and adds listeners for mouseover,
             * mouseout, and click.
             */
            loadMap: function() {
                var plugin = this;
                var mapWrapper = plugin.options.mapWrapper;
                var svgPaths = plugin.options.svgPaths;

                $(svgPaths).each(function() { plugin.pathInit($(this)); });
                mapWrapper.removeClass('loading');
                mapWrapper.on("mouseover", svgPaths, function () { plugin.pathMouseover($(this)); });
                mapWrapper.on("mouseout", svgPaths, function () { plugin.pathMouseout($(this)); });
                mapWrapper.on("click", svgPaths, function () { plugin.pathClick($(this)); });
            },

            /**
             * Gets the appropriate attribute where the name is stored in
             * the SVG, and passes that to countAndColor.
             *
             * @param path SVG path to apply styles to.
             */
            pathInit: function( path ) {
                var plugin = this;

                if ( plugin.options.type === 'state' ) {
                    plugin.countAndColor( path, path.attr( 'id' ) );
                } else if ( plugin.options.type === 'county'  ) {
                    plugin.countAndColor( path, path.attr( 'label' ) );
                }
            },

            /**
             * On state/county hover, show a tool tip with the name and
             * property count.
             *
             * @param path SVG path of state/county.
             */
            pathMouseover: function( path ) {
                var plugin = this;
                var label = '';
                var count = 0;

                if ( plugin.options.type === 'state' ) {
                    label = plugin.mapData[path.attr( 'id' )].name; // Name of state.
                    count = plugin.mapData[path.attr( 'id' )] ? plugin.mapData[path.attr( 'id' )].count : 0;
                } else if ( plugin.options.type === 'county'  ) {
                    label = path.attr( 'label' );
                    count = plugin.mapData[label] ? plugin.mapData[label].count : '0';
                }

                plugin.options.activator.BAToolTip({
                    tipOpacity: 1,
                    tipOffset: 20
                });
                plugin.options.tip.html( '<span>' + label + ' (' + count + ')</span>' );
            },

            /**
             * On state/county mouseout, removed the tooltip.
             */
            pathMouseout: function() {
                var plugin = this;
                plugin.options.activator.BAToolTip({
                    tipOpacity: 0
                });
                plugin.options.tip.html('');
            },

            /**
             * On state/county click, get the link address from the AJAC function, and
             * send the browser there.
             *
             * @param path
             */
            pathClick: function ( path ) {
                var plugin = this;
                var label = '';

                switch (plugin.options.type) {
                    case 'state' :
                        label = path.attr('id');
                        window.location.href = plugin.mapData[path.attr('id')].link;
                        break;

                    case 'county' :
                        label = path.attr('label');
                        window.location.href = plugin.mapData[path.attr('label')].link;
                        break;
                }
            },

            /**
             * Uses the name (label) of a path to get the property count from the
             * returned results, and adds a class based on the number of
             * properties in in that state/county.
             *
             * @param path SVG path to add class to.
             * @param label Name of state/county as returned by getMapData.
             */
            countAndColor: function( path, label ) {
                var plugin = this;

                if ( plugin.mapData[label] ) {
                    var count = plugin.mapData[label].count;
                    path.addClass('has-properties');

                    if ( count > 0 && count <= 5 ) {
                        path.addClass('property-count-low');
                    } else if ( count >= 6 && count <= 10 ) {
                        path.addClass('property-count-med');
                    } else if ( count > 10 ) {
                        path.addClass('property-count-high');
                    }
                }
            }
        };

        // Publicly available functions.
        return {
            /**
             * Call function to initialize the maps.
             */
            init: function() {
                adlMap.getMapData();
            }
        };
    };
})(jQuery);
